<template>
  <div class="transparent-tab">
    <div class="transparent-tab-btn-up" v-if="!visible">
      <a-button shape="round" icon="caret-up" type="primary" @click="handleOpenOrClose"></a-button>
    </div>
    <div class="transparent-tab-btn-down" v-else>
      <a-button shape="round" icon="caret-down" type="primary" @click="handleOpenOrClose"></a-button>
    </div>
    <div class="transparent-tab-wrapper" v-show="visible">
      <a-tabs :activeKey="activeKey" :animated="false">
        <a-tab-pane key="1" :tab="$t('分区计量')">
          <div>
            <a-table
              :columns="columns"
              :data-source="dataSource"
              :pagination="ipagination"
              :loading="loading"
              rowKey="id"
              :scroll="{ x: true, y: 120 }"
              size="small"
              @change="handleTableChange"
              :customRow="customRow"
            >
            <template slot="action" slot-scope="text, record">
              <a @click.stop="handleEdit(record)">{{ $t('编辑') }}</a>
              <a-divider type="vertical" />
              <a v-if="record.showFlag==0" @click.stop="handleShowOrHide(record)">{{ $t('显示') }}</a>
              <a v-if="record.showFlag==1" @click.stop="handleShowOrHide(record)">{{ $t('隐藏') }}</a>
            </template>
            </a-table>
          </div>
        </a-tab-pane>
        <div slot="tabBarExtraContent">
          <a-input
            size="small"
            :placeholder="$t('请输入分区名称')"
            v-model="model.name"
            @pressEnter="searchQuery"
          ></a-input>
        </div>
      </a-tabs>
    </div>
    <Components3EditModal ref="Components3EditModalRef" @ok="getData"/>
  </div>
</template>
      
  <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import vueSeamlessScroll from 'vue-seamless-scroll'
import JInput from '../../../../components/jeecg/JInput.vue'
import Components3EditModal from './Components3EditModal.vue'
export default {
  name: 'modal',
  components: {
    vueSeamlessScroll,
    JInput,
    Components3EditModal
  },
  data() {
    return {
      title: this.$t('组件2'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      url: {
        getUsedTopology: '/jeecg-gis/topology/topology/getUsedTopology',
        list: '/jeecg-gis/area/list',
        edit: "/jeecg-gis/area/edit"
      },
      activeKey: '1',
      list: [],
      loading: false,
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '15'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' ' + this.$t('共{total}条', { total })
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      versionForm: {},
      currentRow: {},
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        { title: this.$t('项目编码'), dataIndex: 'projectCode', align: 'center' },
        { title: this.$t('编码'), dataIndex: 'code', align: 'center' },
        { title: this.$t('名称'), dataIndex: 'name', align: 'center' },
        {
          title: this.$t('是否显示'),
          dataIndex: 'showFlag',
          align: 'center',
          customRender: (t, r, index) => {
            if (t==1) {
              return this.$t('是')
            } else if (t==0) {
              return this.$t('否')
            }
          },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          width: 140,
        },
      ]
    },
  },
  mounted() {
    getAction(this.url.getUsedTopology).then(res => {
      if (res.success) {
        this.versionForm = res.result
        this.getData()
      }
    })
  },
  methods: {
    searchQuery() {
      this.ipagination.current = 1
      this.getData()
    },
    handleTableChange(pagination) {
      this.ipagination = pagination
      this.getData()
    },
    customRow(record, index) {
      return {
        on: {
          click: e => {
            this.currentRow = record;
            this.$emit('handleLocation',this.currentRow);
          },
        },
      }
    },
    getData() {
      let params = {
        projectCode: this.versionForm.projectCode,
        name: this.model.name?`*${this.model.name}*`:'',
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
      }
      getAction(this.url.list, params).then(res => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleOpenOrClose() {
      this.visible = !this.visible
    },
    //  显示隐藏
    handleShowOrHide(record){
      postAction(this.url.edit, {id:record.id,showFlag:record.showFlag==1?0:1}).then(res => {
        if (res.success) {
          this.$message.success(this.$t('操作成功！'));
          this.getData()
          this.$emit('change');
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleEdit(record) { 
      this.$refs.Components3EditModalRef.init(record)
    },
  },
}
</script>
  <style lang="less" scoped>
.transparent-tab {
  width: 100%;
  position: absolute;
  bottom: 590px;
}
.transparent-tab-wrapper {
  height: 240px;
  width: 100%;
  position: absolute;
  right: 0;
  left: 0;
  bottom: -600px;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
.transparent-tab-btn-up {
  width: 100%;
  height: 40px;
  position: absolute;
  right: 0;
  left: 0;
  bottom: -600px;
  z-index: 999;
  text-align: center;
}
.transparent-tab-btn-down {
  width: 100%;
  height: 40px;
  position: absolute;
  right: 0;
  left: 0;
  bottom: -360px;
  z-index: 999;
  text-align: center;
}
::v-deep .ant-tabs-bar {
  margin: 0;
}
::v-deep .ant-tabs-nav-container {
  color: #fff;
  background: #464c5c;
  margin-top: 0;
  border-radius: 6px 0 0 0;
}
::v-deep .ant-tabs-extra-content {
  background: #464c5c;
  border-radius: 0 6px 0 0;
  padding-right: 10px;
}
::v-deep .ant-tabs-tabpane {
  //   padding: 10px;
}
.ant-tabs {
  color: #fff;
}
::v-deep .ant-tabs-nav-container {
  line-height: 1.6;
}
::v-deep .ant-table-thead > tr > th {
  color: #fff;
  background-color: rgba(70, 76, 92, 0.5) !important;
}
::v-deep .ant-table-tbody > tr > td {
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border: none;
}
::v-deep .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
::v-deep .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
::v-deep .ant-table-thead > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
::v-deep .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: rgba(0, 0, 0, 0.5);
}
::v-deep .ant-table-body {
  overflow: auto !important;
}
::v-deep .ant-table-placeholder {
  background: transparent;
  .ant-empty-normal {
    color: #fff;
  }
}
::v-deep .ant-table-pagination.ant-pagination {
  margin: 5px 0;
}
::v-deep .ant-pagination,
::v-deep .ant-pagination-item a {
  color: #fff;
}
::v-deep .ant-pagination-item-active a {
  color: #1890ff;
}
::v-deep .ant-table-row-cell-break-word a{
  color: #fff;
}
::v-deep .ant-btn-primary{
  background-color: #464c5c;
  border-color: #464c5c;
}
</style>